/*
PURPOSE: User mention component with colored text styling

USE CASES:
- Render @mentions as clickable colored text
- Provide hover states and click navigation
- Visually distinguish mentions from regular text and URLs

DOMAIN BOUNDARIES:
- Responsible for mention styling only
- Does NOT handle mention detection or validation
- Presentation component only

ASSUMPTIONS:
- Mentions have been validated and resolved with user IDs
- Colored text with hover underline for clickability
- Clickable with hover effects
*/

import React from 'react';
import { useNavigate } from 'react-router-dom';

interface MentionBubbleProps {
  userId: string;
  displayName: string;
  children: string; // The text to display (e.g., "@Dan Mallrat")
}

const MentionBubble: React.FC<MentionBubbleProps> = ({
  userId,
  displayName,
  children
}) => {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(`/u/${userId}`);
  };

  return (
    <span
      onClick={handleClick}
      className="
        text-coral-pink
        font-semibold
        hover:underline
        cursor-pointer
        transition-all
        duration-200
      "
      title={`View ${displayName}'s profile`}
      data-mention-user-id={userId}
    >
      {children}
    </span>
  );
};

export default MentionBubble;
